import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ButtonBase from 'components/button/Base';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => ({
    root: {
        padding: 20,
        width: 440,
        background: theme.colors.white
    },
    delete: {
        background: `${theme.colors.burntSlena} !important`
    }
}));

function ConfirmDeleteGroupBox({ groupName = 'Empty Group Name', handleCancel, handleAgreed }) {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <Grid container wrap="nowrap" direction="column" spacing={4} className={classes.root}>
            <Grid item>
                <Typography variant="h4">
                    {t('global_delete')} {groupName}
                </Typography>
            </Grid>
            <Grid item>
                <Grid container spacing={2} direction="column">
                    <Grid item>
                        <Typography variant="body1">{t('delete_group_confirm_what_happens')}</Typography>
                    </Grid>
                    <Grid item>
                        <Typography variant="body2">• {t('delete_group_confirm_members_of_this_group')}</Typography>
                    </Grid>
                    <Grid item>
                        <Typography variant="body2">• {t('delete_group_confirm_all_views_shared')}</Typography>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item>
                <Grid wrap="nowrap" container direction="row" alignItems="center" justify="flex-end" spacing={2}>
                    <Grid item>
                        <ButtonBase onClick={handleCancel} width={100} variant="outlined">
                            {t('global_cancel')}
                        </ButtonBase>
                    </Grid>
                    <Grid item>
                        <ButtonBase onClick={handleAgreed} width={100} variant="contained" color="secondary">
                            {t('global_delete')}
                        </ButtonBase>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}
export default React.memo(ConfirmDeleteGroupBox);
